/* eslint-disable no-unused-vars */
import { obterDataFormatada } from "../../../../../utils";

export function createBodyDadosCadastraisCargaPatrimonial(doc, ibp) {

  doc.setFont("", "bold");
  doc.text(`TOMBAMENTO: ${ibp[0].numTombamento}`, 10, 40, null, null, "left");

  doc.text(
    `TOMBAMENTO SAMP: ${ibp[0].s_numTombAntigo}`,
    10,
    44,
    null,
    null,
    "left"
  );

  doc.text(`Nº SERIE: ${ibp[0].numSerie}`, 10, 48, null, null, "left");

  doc.text(
    `SITUAÇÃO: ${ibp[0].situacao === 1 ? "Ativo" : "Inativo"}`,
    10,
    52,
    null,
    null,
    "left"
  );

  
  // const generateDataTarefa = () => {
    //   const result = [];
    
    if (ibp) {
      ibp.map((c) => {
        
           doc.text(
             `--------------------------------------------------------------------------------------------------------------------------------------------------------------------`,
             10,
             56,
             null,
             null,
             "left"
           );
        
          doc.setFont("", "normal");

          

        // result.push({
        //   "N° TOMB. SPALM": c.numTombamento,
        //   "N° TOMB. SAMP": c.s_numTombAntigo,
        //   "CÓDIGO PRODUTO": c.itemRegEntrada.produto.id.toString(),
        //   DESCRIÇÃO: c.itemRegEntrada.produto.descricaoResumida,
        //   MODELO: c.modelo.descricao,
        //   "DATA AQUISIÇÃO": obterDataFormatada(c.dataEntrada),
        //   "VALOR ATUAL (R$)": c.valor.toFixed(2).replace(".", ","),
        //   BR: c.relacionado === 0 ? "Não" : "Sim",
        //   "UNIDADE ADM.": c.lotacao.departamento.descricao,
        //   "LOCALIZAÇÃO FÍSICA": c.localArmazenamento.descricao,
        //   STATUS: c.status.descricao,
        //   "UTILIZADO POR": "-",
        // });
      });
    }

    // return result;
  // };

  // const createHeadersTarefa = (keys) => {
  //   const result = [];
  //   for (let i = 0; i < keys.length; i += 1) {
  //     result.push({
  //       id: keys[i],
  //       name: keys[i],
  //       prompt: keys[i],
  //       width:
  //         (keys[i] === "N° TOMB. SPALM" && 28) ||
  //         (keys[i] === "N° TOMB. SAMP" && 27) ||
  //         (keys[i] === "VALOR ATUAL (R$)" && 25) ||
  //         (keys[i] === "DESCRIÇÃO" && 40) ||
  //         (keys[i] === "BR" && 15) ||
  //         (keys[i] === "CÓDIGO PRODUTO" && 27) ||
  //         (keys[i] === "MODELO" && 27) ||
  //         (keys[i] === "STATUS" && 27) ||
  //         (keys[i] === "UNIDADE ADM." && 37) ||
  //         35,
  //       align: "center",
  //       padding: 0,
  //     });
  //   }
  //   return result;
  // };

  // const headersTarefa = createHeadersTarefa([
  //   "N° TOMB. SPALM",
  //   "N° TOMB. SAMP",
  //   "CÓDIGO PRODUTO",
  //   "DESCRIÇÃO",
  //   "MODELO",
  //   "DATA AQUISIÇÃO",
  //   "VALOR ATUAL (R$)",
  //   "BR",
  //   "UNIDADE ADM.",
  //   "LOCALIZAÇÃO FÍSICA",
  //   "STATUS",
  //   "UTILIZADO POR",
  // ]);

  // doc.table(10, 55, generateDataTarefa(), headersTarefa, {
  //   fontSize: 8,
  //   autoSize: false,
  // });
}
